import { $el, $elParent, getTargets } from 'src/scripts/utils/utils'
import { ShopComponent } from '.'
import { SidebarFilters } from './sidebar-filters'
import { BodyElement } from 'src/scripts/components/body-element/body-element'

const SHOP_SELECTOR = 'shop-component'
const BODY_ELEMENT_SELECTOR = 'body-element'

export class SidebarFiltersDesktop extends SidebarFilters {
  handleSectionLoad = (): void => {}

  change(): void {
    const shop: ShopComponent = $el(SHOP_SELECTOR)

    if (shop) {
      this.createQuery()
      shop.updateBySearchParams(this.searchParams)
    }
  }

  async open(event?: any): Promise<void> {
    const bodyElement: BodyElement = $el(BODY_ELEMENT_SELECTOR)
    const isEmbedFilters = this.hasAttribute('is-embed-filters')

    if (isEmbedFilters && window.scrollY > 0) {
      bodyElement.setScrollLock()
      await super.open(event)
      bodyElement.unsetScrollLock()
    } else {
      await super.open(event)
    }
  }

  handleSidebarFocusout = event => {
    const focusTarget = event.relatedTarget
    const isEmbedFilters = this.hasAttribute('is-embed-filters')

    if (isEmbedFilters) {
      return
    }

    if (!focusTarget || !this.contains(focusTarget)) {
      const { firstTarget } = getTargets(this.element)

      firstTarget.focus()
    }
  }

  initFocus(): void {}
}
